import React, { FC } from "react";

export interface BareLayoutProps {
    children?: JSX.Element[] | JSX.Element;
}

const BareLayout: FC<BareLayoutProps> = (props: BareLayoutProps) => {
    return (
        <>
            {props.children}
        </>
    );
};

export { BareLayout };
